/**
 * Core API
 * Core API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TipoEnvasesDTO { 
    fechaAlta?: string;
    creadoPor?: string;
    fechaModificacion?: string;
    modificadoPor?: string;
    id?: number;
    descripcion?: string;
    orden?: number;
    tipologia1?: TipoEnvasesDTO.Tipologia1Enum;
    tipologia2?: TipoEnvasesDTO.Tipologia2Enum;
    tipologia3?: TipoEnvasesDTO.Tipologia3Enum;
    deleted?: string;
    deletedBy?: string;
}
export namespace TipoEnvasesDTO {
    export type Tipologia1Enum = 'PRIMARIO' | 'SECUNDARIO' | 'TERCIARIO';
    export const Tipologia1Enum = {
        Primario: 'PRIMARIO' as Tipologia1Enum,
        Secundario: 'SECUNDARIO' as Tipologia1Enum,
        Terciario: 'TERCIARIO' as Tipologia1Enum
    };
    export type Tipologia2Enum = 'PRIMARIO' | 'SECUNDARIO' | 'TERCIARIO';
    export const Tipologia2Enum = {
        Primario: 'PRIMARIO' as Tipologia2Enum,
        Secundario: 'SECUNDARIO' as Tipologia2Enum,
        Terciario: 'TERCIARIO' as Tipologia2Enum
    };
    export type Tipologia3Enum = 'PRIMARIO' | 'SECUNDARIO' | 'TERCIARIO';
    export const Tipologia3Enum = {
        Primario: 'PRIMARIO' as Tipologia3Enum,
        Secundario: 'SECUNDARIO' as Tipologia3Enum,
        Terciario: 'TERCIARIO' as Tipologia3Enum
    };
}


